if (!customElements.get('header-extend-new')) {
  customElements.define(
    'header-extend-new',
    class extends HTMLElement {
      constructor() {
        super();
        this.scrollListener();
      }

      scrollListener() {
        document.addEventListener('scroll', () => {
          this.classList.toggle('sticky-start', window.scrollY > 50);
        });
      }
    }
  );
}
